export default __webpack_public_path__ + "static/media/beton_4.cb41af80.webp";